const formatAttendDate = (timestamp) => {

    let year = timestamp.toString().substring(0,4);
    console.log(year)
    let month = timestamp.toString().substring(5,7);
    const d = timestamp.toString().substring(8,10);
    let day = new Date( year, month, d).toString().substring(0,4);


        switch (month){
            case '01':
                month = 'Jan';
                break;
            case '02':
                month = 'Feb';
                break;
            case '03':
                month = 'Mar';
                break;
            case '04':
                month = 'Apr';
                break;
            case '05':
                month = 'May';
                break;
            case '06':
                month = 'Jun';
                break;
            case '07':
                month = 'Jul';
                break;
            case '08':
                month = 'Aug';
                break;
            case '09':
                month = 'Sep';
                break;
            case '10':
                month = 'Oct';
                break;
            case '11':
                month = 'Nov';
                break; 
            case '12':
                month = 'Dec';
                break;
                default:   
            month = month
        };
    console.log(day)

    return `${day},${" "}${month}${" "}${d}`
}

export default formatAttendDate;